import { z } from "zod";

export const ReportFormat = z.enum(["Pdf", "Excel"]);

export type ReportFormatEnum = z.infer<typeof ReportFormat>;

export const ReportFormatDisplayName: Record<ReportFormatEnum, string> = {
  [ReportFormat.enum.Pdf]: "PDF",
  [ReportFormat.enum.Excel]: "Excel",
};

export const ReportFormatFileType: Record<ReportFormatEnum, string> = {
  [ReportFormat.enum.Pdf]: "pdf",
  [ReportFormat.enum.Excel]: "xlsx",
};
